import React, { useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from 'context/app-context/AppContext';

import NavCircle from './Navigation/NavCircle';
import './Navigation.css';

function Navigation(props) {
	const { navigationTitle, setDisplayedQuoteNumber } = useContext(AppContext);

	const done = 100;
	const [style, setStyle] = React.useState({});

	useEffect(() => {
		const qn = window.localStorage.getItem('quote_number');
		setDisplayedQuoteNumber(qn);

		const timeout = setTimeout(() => {
			const newStyle = {
				opacity: 1,
				height: `${done}%`,
			};
			setStyle(newStyle);
		}, 0);

		return () => {
			clearTimeout(timeout);
		};
	}, []);

	let navBar_css = 'nav_bar';
	let property_css = 'nav_bar property_bar';
	let coverages_css = 'nav_bar coverages_bar';
	let nextSteps_css = 'nav_bar nextstep_bar';

	if (props.page === 0) {
		navBar_css += ' inActive';
		property_css += ' inActive';
		coverages_css += ' inActive';
		nextSteps_css += ' inActive';
	}
	if (props.page === 2) {
		navBar_css += ' progress-done';
		property_css += ' inActive';
		coverages_css += ' inActive';
		nextSteps_css += ' inActive';
	}
	if (props.page === 3) {
		property_css += ' progress-done';
		coverages_css += ' inActive';
		nextSteps_css += ' inActive';
	}
	if (props.page === 4) {
		coverages_css += ' progress-done';
		nextSteps_css += ' inActive';
	}

	const { page } = props;

	const navStepsStatus = {
		propertyAddress: page === 0 ? 'active' : 'completed',
		propertyInfo:
			page === 2 ? 'active' : page < 2 ? 'inactive' : 'completed',
		discounts: page === 3 ? 'active' : page < 3 ? 'inactive' : 'completed',
		yourEstimate: page === 4 ? 'completed' : 'inactive',
	};

	const showTitle = props.page !== 0 && props.page !== 1 && navigationTitle;

	return (
		<div className="navigationMenu">
			{showTitle && <p className="quote_header">{navigationTitle}</p>}
			{props.hide ? (
				<></>
			) : (
				<>
					<ul>
						<li className="list">
							<Link
								to="/"
								className="link"
								style={
									props.progress <= 1
										? { pointerEvents: 'none' }
										: { textDecoration: 'none' }
								}
							>
								<div className={navBar_css} style={style}></div>
								<NavCircle
									variant={navStepsStatus.propertyAddress}
								/>
								<span
									className={
										navStepsStatus.propertyAddress ===
										'inactive'
											? 'nav_option'
											: `nav_option_${navStepsStatus.propertyAddress}`
									}
								>
									Property Address
								</span>
							</Link>
						</li>
					</ul>

					<ul>
						<li className="list">
							<Link
								to="/PropertyInfo"
								style={
									props.progress <= 2
										? { pointerEvents: 'none' }
										: { textDecoration: 'none' }
								}
							>
								<div className={property_css} style={style}>
									{' '}
								</div>
								<NavCircle
									variant={navStepsStatus.propertyInfo}
								/>
								<span
									className={
										navStepsStatus.propertyInfo ===
										'inactive'
											? 'nav_option'
											: `nav_option_${navStepsStatus.propertyInfo}`
									}
								>
									Property Information
								</span>
							</Link>
						</li>
					</ul>
					<ul>
						<li className="list">
							<Link
								to="/Discounts"
								style={
									props.progress <= 3
										? { pointerEvents: 'none' }
										: { textDecoration: 'none' }
								}
							>
								<div className={coverages_css} style={style} />
								<NavCircle variant={navStepsStatus.discounts} />
								<span
									className={
										navStepsStatus.discounts === 'inactive'
											? 'nav_option'
											: `nav_option_${navStepsStatus.discounts}`
									}
								>
									Discounts
								</span>
							</Link>
						</li>
					</ul>

					<ul>
						<li className="list">
							<Link
								to="/Coverages"
								style={
									props.progress <= 4
										? { pointerEvents: 'none' }
										: { textDecoration: 'none' }
								}
							>
								<div className={nextSteps_css} style={style} />
								<NavCircle
									variant={navStepsStatus.yourEstimate}
								/>
								<span
									className={
										navStepsStatus.yourEstimate ===
										'inactive'
											? 'nav_option'
											: `nav_option_${navStepsStatus.yourEstimate}`
									}
								>
									Your Estimate
								</span>
							</Link>
						</li>
					</ul>
				</>
			)}
		</div>
	);
}

export default Navigation;
